import { render, staticRenderFns } from "./ECommerce.vue?vue&type=template&id=060b2c0e&scoped=true"
import script from "./ECommerce.vue?vue&type=script&lang=js"
export * from "./ECommerce.vue?vue&type=script&lang=js"
import style0 from "./ECommerce.vue?vue&type=style&index=0&id=060b2c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b2c0e",
  null
  
)

export default component.exports